// 注意：一定是 exports，不是 export，否则会报错，报错信息是下列的中的内容不是 string
module.exports = {
  message: {
    title: "运动品牌",
  },
  placeholder: {
    enter: "请输入您喜欢的品牌",
  },
  brands: {
    nike: "耐克",
    adi: "阿迪达斯",
    nb: "新百伦",
    ln: "李宁",
  },
  menue: {
    detail: "社交详情",
    find: "发现",
    porj: "预设方案",
    custom: "自定义管理",
    customized: "定制采集",
  },
  topHead: {
    select_option_category: "类目",
    select_option_category_holder: "请选择类目",
    select_option_phone: "手机号",
    select_option_work_order: "工单号",
    select_option_customer: "客户发言",
    select_option_seller: "销售发言",
    select_option_brand: "客户",
    select_option_brand_holder: "请选择",
    select_option_postKeyWords: "关键词",
    select_option_postKeyWords_holder: "请输入内容",
    select_option_company: "客户/公司",
    rules_message_search: "客户公司和关键词至少输入一个",
    my_attention: "我的关注",
    login_label: "登录",
    login_out: "退出",
    Chinese: "中文",
    English: "English",
  },
  mainHead: {
    eidtTooltip: "编辑搜索条件",
    platList_weibo: "微博",
    platList_douyin: "抖音",
    platList_xhs: "小红书",
    dateLabel: "时间",
    date_to: "至",
    date_holder: "选择月",
    saveProj: "保存方案",
    tabs_baseInfo: "基本信息",
    tabs_crowdPortrait: "人群画像",
    tabs_talents: "销售",
    tabs_brand: "客户公司",
    tabs_custom: "自定义分析",
    rules_message_search: "客户公司和关键词内容至少输入一个",
    rules_message_search2: "客户公司和关键词内容至少有一个不为空",
    rules_message_range: "时间范围不能为空",
    message_saveProj_success: "方案保存成功",
    message_saveProj_failed: "方案保存失败",
  },
  search: {
    title: "添加搜索条件",
    form_postWord: "关键词",
    form_postWord_tip:
      "支持and、or、not逻辑，和分词用空格隔开；例如：口红 and （唇釉 or 唇彩）not 哑光",
    form_brand: "客户公司",
    form_brand_holder: "输入客户公司关键词",
    form_brand_tip:
      "例如：搜索品牌'苹果/Apple',会筛选出帖子中包含'苹果'或'Apple' 或 '苹果/Apple',且通过语意分析可确定其代表'苹果/Apple' 的帖子。",
    form_category: "类目",
    form_cat_tip: "请选择需要查看的类目，目前仅支持选择叶子类目",
    form_plat: "平台",
    form_platOption_douyin: "抖音",
    form_platOption_weibo: "微博",
    form_platOption_xhs: "小红书",
    form_dateRange: "时间范围",
    form_dateRange_holder: "选择月",
    form_dateRange_to: "至",
    searchBtnLab: "搜  索",
    operation: "操作",
  },
  baseInfo: {
    trend: "趋势",
    posts: "声量",
    posts_toolTip: "总发帖数",
    interaction: "录音时长",
    interaction_toolTip: "评论数+点赞数+转发数",
    platTitle: "平台分布",
    cloudWordTitle: "词云图",
    TalentTitle: "销售Top10榜单",
    PostListLabel: "声量排行",
    IteractionListLabel: "录音时长排行",
    BrandTitle: "客户公司Top10榜单",
    postContent: "录音原文",
    postType_all: "总",
    postType_Forward: "正向",
    postType_back: "负向",
    postType_neutral: "中性",
    selectedCondition: "已选中的条件",
    postKeyWordLabel: "关键词：",
    cloudWordLabel: "词云：",
    kolLabel: "销售:",
    catLabel: "类目：",
    brandLabel: "客户公司：",
    brand: "客户公司",
    originPostLink: "原文链接",
    workOrder: "工单",
    negativePostPercent: "负向声量占比",
    reposts: "转发数",
    comments: "评论数",
    zans: "录音时长",
    participle: "分词",
    frequency: "词频",
    photo: "头像",
    Talent: "销售",
    plant: "平台",
    fansNum: "粉丝数",
    downLoad: "下载",
    downLoading: "下载准备中...",
    ranking: "排名",
    cloud_nameLabel: "词",
    cloud_valueLabel: "数量",
    gender: "性别",
    age: "年龄",
    region: "地域",
    cityLevel: "城市级别",
    interest: "兴趣",
    interestStatistics: "兴趣原文词云及词频统计",
    distribution: "分布",
    concerned: "关注",
    category: "品类",
    user: "用户数",
    tgi: "TGI",
    man: "男性",
    woman: "女性",
  },
  TalentList: {
    allPosts: "全部帖子",
    forwardPosts: "正向帖子",
    backPosts: "负向帖子",
    neutralPosts: "中性帖子",
  },
  proj: {
    title: "预设方案",
    userDefinedName: "自定义名称",
    postsKeyWords: "帖子关键词",
    brand: "客户公司",
    cat: "类目",
    Talent: "销售",
    plant: "平台",
    date: "时间",
    to: " 至 ",
  },
  footer: {
    content_one:
      "电商魔镜的数据全部来自公开页面，电商魔镜与淘宝、天猫、京东、亚马逊等电商平台无直接关联，是一家独立的第三方电商数据机构",
      content_two: "@2023 北京淘幂科技有限公司 ",
      content_icp: "京ICP备15061734号-4 ",
      content_goan: "京公网安备11010502037832号 ",
    content_add:
      "数据由公开页面采集并汇总处理，数据口径和平台及其他机构有所不同，仅供参考，如有差异请以平台官方发布数据为准",
  },
  keywords: "关键词:",
  customer: "客户发言:",
  seller: "销售发言:",
  company: "客户/公司:",
  issue: "工单号:",
  phone: "手机号:",
};
